<template>
	<div id="header" ref="headers">
		<div id="logo">
			<a href="/"><img src="../../assets/image/logo.png"/></a>
		</div>
		<div id="sun-menu">
			<Menu mode="horizontal" active-name="1"  @on-select="GoToURL">
				<template v-for="(item,index) in pageMenuList">
					<Submenu :name="index" v-if="item.list">
			            <template slot="title">{{item.title}}</template>
		                <MenuItem  v-for="(v,j) in item.list" :name="v.src" :key="v.src">
							<template>{{v.title}}</template>
		                </MenuItem>
			        	</Submenu>
					<MenuItem :name="item.src" :key="item.src" v-else >
						<template>{{item.title}}</template>
					</MenuItem>
				</template>
	   		 </Menu>
		</div>
		<div class="phone-menu">
			<div class="menu-icon" @click="showRight=true;"></div>
		</div>
		<Popup class="menu-popup"  v-model="showRight" position="right" :style="{ width: '80%', height: '100%' }">
			<div class="close-btn" @click="showRight=false;"></div>
			<div class="logo-box"><img src="../../assets/image/logo.png"></div>
			<div class="menu-list">
				<Collapse v-model="activeNames">
					<template v-for="(item,index) in pageMenuList">
						<CollapseItem :name="index" v-if="item.list" >
						    <template #title>
						    		<div class="menu-title">{{item.title}}</div>
						    </template>
					   		<template v-if="item.list" v-for="(v,j) in  item.list">
					   			<p class="menu-second">
					   				<a v-if="v.src" :class="v.clicks?'active':''" @click="clickButton(index,j)">{{v.title}}</a>
									<template v-else>{{v.title}}</template>
					   			</p>
					   		</template>
						</CollapseItem>
						<div class="van-collapse-item van-collapse-item--border" v-else>
							<div role="button" tabindex="0" aria-expanded="true" class="van-cell van-cell--clickable van-collapse-item__title van-collapse-item__title--expanded">
								<div class="van-cell__title"><div class="menu-title">{{item.title}}</div></div>
							</div>
						</div>
					</template>
				</Collapse>
			</div>
		</Popup>
		<div class="clear"></div>
	</div>
</template>
<script>
	export default {
		name: 'Header',
		data() {
			return {
				userInfo:null,
				showRight:false,
				activeNames: ['1'],
				pageMenuList:[{
					title:'Silicon Material',
					list:[{
						title:'FZ-production technology',
						src:'/silicon-Material/fz-production-technology'
					},{
						title:'CZ-production technology',
						src:'/silicon-Material/cz-production-technology'
					},{
						title:'Process Options',
						src:'/silicon-Material/process-options'
					}]
				},{
					title:'Semiconductor IC & Discrete Device',
					list:[{
						title:'8-inch silicon wafer line',
						src:'/semiconductor-ic-discrete-device/8-inch-12-inch-wafer-production-line'
					},{
						title:'6 inch silicon wafer line',
						src:'/semiconductor-ic-discrete-device/6-inch-silicon-wafer-line'
					},{
						title:'Production List',
						src:'/semiconductor-ic-discrete-device/production-list'
					}]
				},{
					title:'Semiconductor assembly and testing',
					list:[{
						title:'Manufacturing layout',
						src:'/semiconductor-assembly-and-testing/manufacturing-layout'
					},{
						title:'OSAT Turnkey Service',
						src:'/semiconductor-assembly-and-testing/osat-turnkey-service'
					},{
						title:'Products Strategy',
						src:'/semiconductor-assembly-and-testing/products-trategy'
					},{
						title:'Test Service',
						src:'/semiconductor-assembly-and-testing/test-service'
					},{
						title:'Co-Design Simulation',
						src:'/semiconductor-assembly-and-testing/co-design-simulation'
					},{
						title:'FA& RA Ability',
						src:'/semiconductor-assembly-and-testing/fa-ra-ability'
					},{
						title:'Quality Certification',
						src:'/semiconductor-assembly-and-testing/quality-certification'
					},{
						title:'Expenimental and Analysis ability',
						src:'/semiconductor-assembly-and-testing/expeni-mental-and-analysis-ability'
					}]
				},{
					title:'Precision Stamping Part',
					list:[{
						title:'Precision stamping and injection',
						src:'/precision-stamping-part/precision-stamping-and-injection'
					},{
						title:'Structure parts stamping',
						src:'/precision-stamping-part/structure-parts-stamping'
					},{
						title:'Optical electric products',
						src:'/precision-stamping-part/optical-electric-products'
					},{
						title:'Connectors and plugs',
						src:'/precision-stamping-part/connectors-and-plugs'
					},{
						title:'Tool development and fabrication',
						src:'/precision-stamping-part/tool-development-and-fabrication'
					},{
						title:'FPC SMT',
						src:'/precision-stamping-part/fpc-smt'
					},{
						title:'Optical protective film',
						src:'/precision-stamping-part/optical-protective-film'
					}]
				},{
					title:'About us',
					list:[{
						title:'Contact us',
						src:'/about-us/contact-us'
					}]
				}]
			}
		},
		mounted() {
		},
		created() {
			this.init();
		},
		methods: {
			init:function(){
				var that=this;
				that.$nextTick(function(){
					that.$emit('backHeaderHeight',this.$refs.headers.offsetHeight);
				});
			},
			GoToURL:function(key){
				var that=this;
				window.location.href=key;
			},
			clickButton:function(i,j){
				console.log(i,j);
				console.log(this.pageMenuList[i]["list"][j]);
				var that=this;
				this.$set(this.pageMenuList[i]["list"][j],'clicks',true);
				setTimeout(function() {
				    window.location.href=that.pageMenuList[i]["list"][j]['src'];
				}, 500);
			}
		},
		components: {
			Menu: resolve => require(['iview/src/components/menu/menu.vue'], resolve),
			Submenu: resolve => require(['iview/src/components/menu/submenu.vue'], resolve),
			MenuItem: resolve => require(['iview/src/components/menu/menu-item.vue'], resolve),
			MenuGroup: resolve => require(['iview/src/components/menu/menu-group.vue'], resolve),
			Popup: resolve => require(['vant/lib/popup'], resolve),
			Collapse: resolve => require(['vant/lib/collapse'], resolve),
			CollapseItem: resolve => require(['vant/lib/collapse-item'], resolve),
		}
	}
</script>
<style lang="scss" type="text/css">
</style>



// WEBPACK FOOTER //
// src/components/PublicMould/Header.vue